import { Data_getInstance3f3szy9qmf19h as Data_getInstance } from './adapter/DeletePinMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DeletePinMutation_VariablesAdapter_instance3oybljjiooupn as DeletePinMutation_VariablesAdapter_instance } from './adapter/DeletePinMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(deletePin) {
        this.v6g_1 = deletePin;
      }
      toString() {
        return 'Data(deletePin=' + this.v6g_1 + ')';
      }
      hashCode() {
        return this.v6g_1 == null ? 0 : getBooleanHashCode(this.v6g_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.v6g_1 == other.v6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.w6g_1 = '4959d3041a099d0c81ec21b955af64a4289b42092bf6de72160613a29419fd95';
        this.x6g_1 = 'deletePin';
      }
      g6g() {
        return 'mutation deletePin($input: DeletePinInput!) { deletePin(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var DeletePinMutationClass;
function DeletePinMutation() {
  if (DeletePinMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.y6g_1 = input;
      }
      i6g() {
        return '4959d3041a099d0c81ec21b955af64a4289b42092bf6de72160613a29419fd95';
      }
      operationId() {
        return this.i6g();
      }
      w48() {
        return Companion_instance.g6g();
      }
      j6g() {
        return 'deletePin';
      }
      operationName() {
        return this.j6g();
      }
      q47(writer, customScalarAdapters, withDefaultValues) {
        DeletePinMutation_VariablesAdapter_instance.z6g(writer, this, customScalarAdapters, withDefaultValues);
      }
      p47() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'DeletePinMutation(input=' + this.y6g_1.toString() + ')';
      }
      hashCode() {
        return this.y6g_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePinMutation()))
          return false;
        if (!this.y6g_1.equals(other.y6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePinMutation', VOID, VOID, [Mutation()]);
    DeletePinMutationClass = $;
  }
  return DeletePinMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data1jasy19j4j968,
  DeletePinMutation as DeletePinMutation2z9xaiydj80c8,
};
//endregion

//# sourceMappingURL=DeletePinMutation.mjs.map
